/* eslint-disable class-methods-use-this */
/* eslint-disable no-magic-numbers */
import Phase from '../phase-core/Phase';

const { max, floor, pow } = Math;

export default class Grow extends Phase {
	constructor(length, size) {
		super(length);
		this._size = size;
	}
	getPreludeLength() {
		return 0.5;
	}
	getPostludeLength() {
		return 0.5;
	}
	run({ time, pulse, frame_opts }) {
		frame_opts.size = this._size * max(0, time.beat) + 15 * pow(max(0, pulse * 3 - 2), 10);
		frame_opts.rotation += 0.1 * pow(pulse, 10) * (floor(time.relative + 0.5) & 1 ? -1 : +1);
	}
}
